<template>
  <div class="paiwei pk-content">
    <Header></Header>
    <!-- 状态显示 -->
   <!-- <div class="status-bar">
      <div>连接状态：<span>{{ connectionStatus }}</span></div>
      <div>房间号：<span>{{ roomId || '-' }}</span></div>
      <div>我的等级：Lv.<span>{{ playerInfo.level || '-' }}</span></div>
    </div> -->

    <!-- 创建房间和加入房间按钮 -->
    <div id="roomControl" v-if="showRoomControl">
      <div class="otp-title ac">{{$t('game3T')}}</div>
      <div class="otp-modal paiwei-bg ac">
        <div class="disflex" style="height: 280px;">
          <div class="disflex" style="justify-content: space-evenly;">
            <div class="avatar1">
              <img class="avatar-img-150" :src="info.avatar">
              <div class="name" style="color:#fff">{{info.nickname}}</div>
            </div>
          </div>
        </div>
        <div class="input-div">
          <div class="mt30">
            <button @click="createRoom" class="button btn-red">{{$t('CreateRoom')}}</button>
          </div>
          <div class="input-item mt30" style="background: none;">
            <div class="input-item2 disflex" id="joinRoomGroup">
              <input class="" v-model="roomInput" ref="getFocus2" maxlength="4" type="number" style="width: 100%;height:80px;background: #f1f7ff;border-radius: 10px;" placeholder="">
              <button class="button btn-red" style="padding: 0 10px;min-height: 80px;line-height: 80px;min-width: 160px;margin-left:5px;font-size: 30px;" @click="joinRoom">{{$t('JoinRoom')}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 匹配等待 -->
    <div class="paiwei-content" v-if="gameState === 'matching'">
      <div class="otp-title ac">{{$t('game3T')}}</div>
      <div class="otp-modal wait-bg ac">
        <div class="title fs33" style="padding-top:20px">{{$t('WaitingTips')}}...</div>
          <div v-if="room_id_div" style="padding-top:10px;font-size: 40px;font-weight: 700;color: #ffeb75;">{{$t('RoomID')}}: <span>{{ roomId || '-' }}</span><img id="copycode" :data-clipboard-text="roomId" @click="copy(roomId)" class="ml10" width="60" src="../../static/images/copy.png"></div>
        <div class="disflex mt20">
          <div class="avatar-content disflex" style="justify-content: space-evenly;">
            <div class="avatar1">
              <img class="avatar-img-120" :src="playerInfo.avatar">
              <div class="name">{{ playerInfo.nickname }}</div>
            </div>
            <div class="vs"><img width="80" src="../../static/images/vs.png"></div>
            <div class="avatar2">
              <img class="avatar-img-120" :src="opponentInfo.avatar || '../../static/images/wait-avatar.png'">
              <div class="name">{{ opponentInfo.nickname }}</div>
            </div>
          </div>
        </div>
        <div class="mt10">{{$t('Waiting')}}: {{ waitTime }}s</div>
      </div>
    </div>

    <!-- 对战面板 -->
    <div class="battle-panel" v-if="gameState === 'playing'">

      <!-- 新增倒计时特效 -->
      <div v-if="countdownVisible" class="countdown-overlay">
        <div class="countdown-number" :key="countdownNumber">{{ countdownNumber }}</div>
      </div>

      <div class="score-board">
        <div class="player-card">
          <div class="player-img">
            <img class="avatar" :src="playerInfo.avatar || '../../static/images/default-avatar.png'">
          </div>
          <!-- <div>{{ playerInfo.nickname }}</div> -->
          <div class="g-score">+{{ scores.player }}</div>
        </div>


        <!-- 圆形倒计时 -->
        <div class="timer-container">
          <div class="circular-timer">
            <svg class="timer-svg" viewBox="0 0 36 36">
              <path class="timer-circle-bg"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path class="timer-circle"
                :stroke-dasharray="`${timerProgress}, 100`"
                d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
            <div class="timer-text">{{ countdown }}</div>
          </div>
        </div>
        <div class="player-card">
          <div class="player-img player-img-r">
            <img class="avatar" :src="opponentInfo.avatar || '../../static/images/default-avatar.png'">
          </div>
          <!-- <div>{{ opponentInfo.nickname }}</div> -->
          <div class="g-score g-score-r">+{{ scores.opponent }}</div>
        </div>
      </div>
      <div class="question-content">
        <div class="bar bar-left"><span :style="'height:'+scores.your_score_rate*100+'%'"></span></div>
        <!-- 题目区域 -->
        <div class="question-box">
          <div class="question-meta" v-if="currentQuestionIndex">
            {{ currentQuestionIndex }}/{{ totalQuestions }}
          </div>
          <h3 class="question-title">{{ currentQuestion }}</h3>
          <div class="options">
            <button
              v-for="(option, key) in currentOptions"
              :key="key"
              class="option-btn"
              :class="{
                'correct': answerRevealed && selectedAnswer === key && key === correctAnswer,
                'wrong': answerRevealed && selectedAnswer === key && key !== correctAnswer
              }"
              :disabled="answerRevealed || isAnswerSubmitted"
              @click="selectAnswer(key)"
            >
              <span>{{ key }}. {{ option }}</span>
              <span>
                <img width="46" style="float: right;margin-right: 10px;" v-if="answerRevealed && key === correctAnswer" src="../../static/images/dui.png">
                <img width="46" style="float: right;margin-right: 10px;" v-if="answerRevealed && selectedAnswer === key && key !== correctAnswer" src="../../static/images/cuo.png">
              </span>
            </button>
          </div>
        </div>
        <div class="bar bar-right"><span :style="'height:'+scores.opponent_score_rate*100+'%'"></span></div>
      </div>
    </div>

    <!-- 结果弹窗 -->
    <div class="modal " v-if="gameState === 'ended'">
      <div class="modal-bg"></div>
      <div class="modal-content">
        <div class="match-panel redeem-modal">
          <div style="display: flex;align-items: center; width: 100%;height: 700px;">
            <div style="margin-left: 20px">
              <div class="md-title">{{$t('GameOver')}}</div>
              <div class="image ac">
                <div class="bf-score" v-if="gameResult === 'win'">🎉 {{$t('Congratulations')}}</div>
                <div class="bf-score" v-else-if="gameResult === 'lose'">😢 {{$t('SorryLost')}}</div>
                <div class="bf-score" v-else>🤝 {{$t('Draw')}}</div>
                <div>{{$t('YourScore')}}: {{ scores.player }}</div>
                <div>{{$t('OpponentScore')}}: {{ scores.opponent }}</div>
              </div>
              <div class="btn-bottom disflex mt50">
                <button class="btn btn-none fs33" style="border-radius: 100px;" @click="closeResultModal">{{$t('OK')}}</button>
                <button class="btn btn-blue fs33" @click="restartGame" style="border-radius: 100px;">{{$t('PlayAgain')}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 购买机会 -->
    <Dialog ref="otpDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true" style="min-height: 300px;">
      <div class="" slot="mdBox">
        <div class="otp-title" >{{$t('ChanceEnough')}}</div>
        <div class="otp-modal ac">
          <img style="margin: -40px auto;" src="../../static/images/buy-img.png">
          <div class="otp-font">
            {{$t('BuyChancesC')}}
          </div>
          <div class="mt10 disflex">
            <button class="btn btn-none" style="border: 2px solid #fff;color:#fff;width: auto;min-width: 250px;" @click="cancelOtpDialog">{{$t('Later')}}</button>
            <button class="btn btn-blue" style="width: auto;min-width: 250px;" @click="getSubmit">{{$t('BuyMore')}}</button>
          </div>
        </div>
      </div>
    </Dialog>



  </div>
</template>

<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'
import Clipboard from 'clipboard';
import AudioService from '@/services/AudioService'
export default {
    components:{
		Header,Dialog
    },
  name: 'FriendBattle',
  data() {
    return {
      info:{},
      ws: null,
      connectionStatus: 'Not connected',
      gameState: 'connecting', // connecting, matching, playing, ended
      playerInfo: {
        user_id: null,
        nickname: '',
        avatar: '',
        level: null
      },
      opponentInfo: {
        user_id: null,
        nickname: '',
        avatar: '',
        level: null
      },
      roomId: null,
      room_id_div:true,
      roomInput: '',
      waitTime: 0,
      matchTimer: null,
      currentQuestionIndex: 0,
      totalQuestions: 0,
      currentQuestion: '',
      currentOptions: {},
      correctAnswer: null,
      selectedAnswer: null,
      answerRevealed: false,
      isAnswerSubmitted: false,
      scores: {
        player: 0,
        opponent: 0
      },
      countdown: 0,
      timerInterval: null,
      showResultModal: false,
      modalMyScore: 0,
      modalOpponentScore: 0,
      resultClass: '',
      resultIcon: '🎉',
      resultTitle: '',
      resultTips: '',
      showRoomControl: false,
      totalTime: 10, // 总时间用于计算百分比
      isReStart:0,//是否是再次答题
      // 新增倒计时相关数据
      countdownVisible: false,
      countdownNumber: 3,
      //音效
      audioService: AudioService,
      isBgmPlaying: false
    }
  },
  computed: {
    timerProgress() {
      return (this.countdown / this.totalTime) * 100;
    }
  },
  created() {
    this.getUserInfo();
    this.connect();
    this.resultTitle = this.$t('GameOver')
  },
  mounted(){
    this.audioService.init();
    this.startBackgroundMusic();
  },
  beforeDestroy() {
    this.disconnect();
    this.stopBackgroundMusic();
  },
  methods: {
    copy(item){
        var clipboard = new Clipboard("#copycode");
        clipboard.on("success", (e) => {
          this.$utils.alertText(this.$t('CopySucceeded'),80);
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          //console.log("该浏览器不支持自动复制");
          // 释放内存
          clipboard.destroy();
        });
    },
    getUserInfo(){
      let that =this;
      that.$api.get('/api/user/info',null,r =>{
        that.$parent.returnCode(r,function(){
          that.info = r.data
        });
      })
    },
    connect() {
      this.ws = new WebSocket('wss://demo-battle-api.goquizgo.com/ws');

      this.ws.onopen = () => {
        console.log('WebSocket connected');
        this.connectionStatus = 'WebSocket connected';
        this.login();
      };

      this.ws.onmessage = (e) => {
        const data = JSON.parse(e.data);
        this.handleMessage(data);
      };

      this.ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        this.connectionStatus = 'WebSocket error';
      };

      this.ws.onclose = () => {
        console.log('WebSocket closed');
        this.connectionStatus = 'WebSocket closed';
      };
    },
    login(){
      this.ws.send(JSON.stringify({
        match_type: 'pk',
        action: 'login',
        mobile: localStorage.getItem('mobile')
      }));
    },
    disconnect() {
      if (this.ws) {
        this.ws.close();
      }
      this.clearTimers();
    },
    clearTimers() {
      if (this.matchTimer) {
        clearInterval(this.matchTimer);
        this.matchTimer = null;
      }
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    handleMessage(data) {
      if (data.match_type !== 'pk'){
        return;
      }
      switch(data.action) {
        case 'login_success':
          this.handleLoginSuccess(data);
          break;
        case 'chance_error':
          this.handleChanceError(data);
          break;
        case 'create_success':
          this.handleRoomCreated(data);
          break;
        case 'enter_room':
          this.startGame(data);
          break;
        case 'match_waiting':
          this.showMatchPanel(data);
          break;
        case 'new_question':
          this.showQuestion(data);
          break;
        case 'answer_result':
          this.handleAnswerResult(data);
          break;
        case 'game_over':
          this.endGame(data);
          break;
        case 'join_error':
          this.joinError(data);
          break;
        case 'timeout':
          this.playSound('basic.wrong')
          break;
        //断开重连
        case 'reconnect_room':
          this.handleReconnect(data);
          break;
        case 'error':
          console.log(data.message);
          break;
      }
    },
    createRoom() {
      this.ws.send(JSON.stringify({
        match_type: 'pk',
        action: 'create_room'
      }));
    },
    joinRoom() {
      if (this.roomInput) {
        this.ws.send(JSON.stringify({
          match_type: 'pk',
          action: 'join_room',
          room_id: this.roomInput
        }));
      } else {
        this.$utils.alertText(this.$t('enterRoomID'),80);
      }
    },
    showMatchPanel(data) {
      this.roomId = data.data.room_id;
      this.showRoomControl = false;
      this.gameState = 'matching';
      this.waitTime = 0;
      this.matchTimer = setInterval(() => {
        this.waitTime++;
      }, 1000);
    },
    handleLoginSuccess(data) {
      this.showRoomControl = true;
      this.playerInfo = {
        user_id: data.data.user_id,
        nickname: data.data.nickname,
        avatar: data.data.avatar,
        level: data.data.level
      };
    },
    handleRoomCreated(data) {
      this.roomId = data.data.room_id;
      this.gameState = 'matching';
      this.showRoomControl = false;
    },
    startGame(data) {
      this.clearTimers();
      this.clearQuestion();

      this.timeTotal = 3;
      this.timeLeft = 3;
      this.startTimer();

      this.startCountDown();

      this.showRoomControl = false;
      this.gameState = 'playing';
      this.roomId = data.room_id;

      // 确定玩家和对手
      const player1 = data.opponent.player1;
      const player2 = data.opponent.player2;

      if (player1.user_id === this.playerInfo.user_id) {
        this.opponentInfo = {
          user_id: player2.user_id,
          nickname: player2.nickname,
          avatar: player2.avatar,
          level: player2.level
        };
      } else {
        this.opponentInfo = {
          user_id: player1.user_id,
          nickname: player1.nickname,
          avatar: player1.avatar,
          level: player1.level
        };
      }

      // 重置分数
      this.scores = { player: 0, opponent: 0 };
    },
    showQuestion(data) {
      this.currentQuestionIndex = data.question_no;
      this.totalQuestions = data.question_count;
      this.currentQuestion = data.question;
      this.currentOptions = data.options;
      this.answerRevealed = false;
      this.isAnswerSubmitted = false;
      this.selectedAnswer = null;
      this.totalTime = data.timeout || 10;
      this.startTimer(this.totalTime);
    },
    startTimer(seconds) {
      seconds = Math.max(1, parseInt(seconds) || 10);

      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }

      let remaining = seconds;
      this.countdown = remaining;

      this.timerInterval = setInterval(() => {
        remaining = Math.max(0, remaining - 1);
        this.countdown = remaining;

        if (remaining <= 0) {
          clearInterval(this.timerInterval);
          this.disableOptions();
        }
      }, 1000);
    },
    selectAnswer(answerKey) {
      this.startBackgroundMusic()
      this.selectedAnswer = answerKey;
      this.isAnswerSubmitted = true;

      this.ws.send(JSON.stringify({
        match_type: 'pk',
        action: 'submit_answer',
        room_id: this.roomId,
        question_no: this.currentQuestionIndex,
        answer: answerKey
      }));
    },
    handleAnswerResult(data) {
      if (data.user_id === this.playerInfo.user_id) {
        this.scores.player = data.your_score;
        this.scores.opponent = data.opponent_score;
        this.scores.your_score_rate = data.your_score_rate;
        this.scores.opponent_score_rate = data.opponent_score_rate;
        this.correctAnswer = data.correct_answer;
        this.answerRevealed = true;
        if (data.is_correct){
          //答对
          this.playSound('basic.correct')
        }else {
          //答错
          this.playSound('basic.wrong')
        }
      } else {
        this.scores.opponent = data.your_score;
      }
    },
    disableOptions() {
      this.isAnswerSubmitted = true;
    },
    endGame(data) {
      this.clearTimers();
      this.clearQuestion();
      this.gameState = 'ended';
      this.showResult(data);
    },
    showResult(data) {
      const results = data.results;
      const maxScore = Math.max(...results.map(player => player.score));
      const winners = results.filter(player => player.score === maxScore);
      const currentPlayer = results.find(player => player.user_id === this.playerInfo.user_id);

      if (!currentPlayer) {
        this.gameResult = null;
      } else if (currentPlayer.score === maxScore) {
        this.gameResult = winners.length > 1 ? 'draw' : 'win';
        this.playSound('sfx.win')
      } else {
        this.playMusic();
        this.playSound('sfx.lose')
      }
      this.scores.player = currentPlayer.score;
      this.scores.opponent = results.find(player => player.user_id !== this.playerInfo.user_id).score;
    },
    closeResultModal() {
      this.showResultModal = false;
      this.roomInput = '';
      this.resetToLobby();
    },
    restartGame() {
      this.clearTimers();
      this.clearQuestion();
      this.isReStart = 1;
      this.showResultModal = false;
      this.currentQuestionIndex = 0;
      this.room_id_div = false;
      this.scores = { player: 0, opponent: 0 };
      this.ws.send(JSON.stringify({
        match_type: 'pk',
        action: 'one_more',
        room_id: this.roomId
      }));
      this.gameState = 'playing';
    },
    resetToLobby() {
      this.gameState = 'connecting';
      this.showRoomControl = true;
      this.roomId = null;
    },
    joinError(data) {
      this.$utils.alertText(data.msg,80);
    },
    clearQuestion(){
      this.currentQuestionIndex = 0;
      this.totalQuestions = 0;
      this.currentQuestion = "";
      this.currentOptions = {};
      this.timeTotal = 10;
      this.timeLeft = 0;
      this.answerRevealed = false;
      this.isAnswerSubmitted = false;
      this.selectedAnswer = null;
    },
    //恢复链接
    handleReconnect(data){
      this.showRoomControl = false;
      this.roomId = data.room_id;
      //恢复玩家信息
      this.playerInfo = {
        user_id: data.playerInfo.user_id,
        nickname: data.playerInfo.nickname,
        avatar: data.playerInfo.avatar,
        level: data.playerInfo.level
      };
      //恢复玩家和对手
      const player1 = data.opponent.player1;
      const player2 = data.opponent.player2;
      if (player1.user_id === this.playerInfo.user_id) {
        this.opponentInfo = {
          user_id: player2.user_id,
          nickname: player2.nickname,
          avatar: player2.avatar,
          level: player2.level
        };
      } else {
        this.opponentInfo = {
          user_id: player1.user_id,
          nickname: player1.nickname,
          avatar: player1.avatar,
          level: player1.level
        };
      }
      //恢复分数信息
      this.scores.player = data.opponent_score.your_score;
      this.scores.opponent = data.opponent_score.opponent_score;
      this.scores.your_score_rate = data.opponent_score.your_score_rate;
      this.scores.opponent_score_rate = data.opponent_score.opponent_score_rate;
      //恢复题目
      this.currentQuestionIndex = data.question_data.question_no;
      this.totalQuestions = data.question_data.question_count;
      this.currentQuestion = data.question_data.question;
      this.currentOptions = data.question_data.options;
      this.timeTotal = data.question_data.timeout || 10;
      this.timeLeft = this.timeTotal;
      this.startTimer();
      //恢复答题结果
      this.isAnswerSubmitted = data.current_question_result.isAnswerSubmitted;
      this.selectedAnswer = data.current_question_result.user_answer;
      if (data.current_question_result.user_answer){
        this.correctAnswer = data.current_question_result.correctAnswer;
        this.answerRevealed = true;
      }
      this.gameState = 'playing';
    },
    handleChanceError(data){
      let that =this;
      that.gameState = 'connecting'
      that.$refs.otpDialog.showMaskFun();
    },
    cancelOtpDialog(){
      this.$refs.otpDialog.closeMask();
      this.$router.push({path:'/'});
    },
    getSubmit(){
      let that = this
      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy',null,r =>{
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if (r.code == 1){
            that.$refs.otpDialog.closeMask();
            that.$utils.alertText(r.msg,80, 800);
            if (that.isReStart){
              that.restartGame();
            }
          }else{
            that.$utils.alertText(r.msg,80, 3000);
          }
        });
      })
    },
    startCountDown(){
      // 启动3秒倒计时特效
      this.countdownVisible = true;
      this.countdownNumber = 3;
      this.playSound('sfx.countdown')
      const countdownInterval = setInterval(() => {
        this.countdownNumber -= 1;
        if (this.countdownNumber <= 0) {
          clearInterval(countdownInterval);
          this.countdownVisible = false;
        }
      }, 1000);
    },
    playSound(soundName) {
      this.audioService.play(soundName)
        .then(() => console.log(`${soundName} 播放成功`))
        .catch(e => console.error(`${soundName} 播放失败:`, e));
    },
    startBackgroundMusic() {
      // 如果正在播放，则不再重复播放
      if (this.isBgmPlaying) {
        console.log('背景音乐已在播放中');
        return;
      }
      this.audioService.play('bgm.main', { loop: true })
        .then(() => {
          this.isBgmPlaying = true;
          console.log('背景音乐开始播放');
        })
        .catch(e => {
          console.error('背景音乐播放失败:', e);
          this.isBgmPlaying = false;
        });
    },
    stopBackgroundMusic() {
      this.audioService.stopBackground();
      console.log('背景音乐已停止');
    }
  }
}
</script>

<style scoped>
/* 圆形计时器样式 */
.timer-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
}

.circular-timer {
  position: relative;
  width: 140px;
  height: 140px;
}

.timer-svg {
  width: 100%;
  height: 100%;
  transform: rotate(-90deg);
}

.timer-circle-bg {
  fill: none;
  stroke: #ffffff5c;
  stroke-width: 1;
}

.timer-circle {
  fill: none;
  stroke: #ffffff;
  stroke-width: 1;
  stroke-linecap: round;
  transition: stroke-dasharray 1s linear;
}

.timer-text {
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 32px;
  font-weight: bold;
  color: #333; */

  position: absolute;
  top: 0;
  left: 0;
  width: 80%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6854f8;
  font-size: 40px;
  font-weight: bold;
  border-radius: 50%;
  background: #fff;
  z-index: 1;    margin: 10%;
}

.timer-label {
  margin-top: 10px;
  font-size: 16px;
  color: #666;
}

.result-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.result-content {
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  text-align: center;
  min-width: 600px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
  animation: modalIn 0.3s ease;
}

@keyframes modalIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

.result-icon {
  font-size: 64px;
  margin-bottom: 15px;
}

.result-title {
  color: #333;
  margin: 10px 0 25px;
  font-size: 24px;
}

.score-compare {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 30px;
  margin: 20px 0;
}

.score-item {
  flex: 1;
  padding: 15px;
  border-radius: 8px;
}

.your-score {
  background: #f0f9ff;
  border: 1px solid #1890ff;
}

.opponent-score {
  background: #fff2f0;
  border: 1px solid #ff4d4f;
}

.score-label {
  display: block;
  color: #666;
  margin-bottom: 8px;
}

.score-value {
  font-size: 28px;
  font-weight: bold;
}

.vs-divider {
  font-size: 30px;
  color: #999;
  padding: 0 10px;
}

.result-tips {
  color: #666;
  margin: 20px 0;
  font-size:24px;
}

.confirm-btn {
  background: #1890ff;
  color: white;
  border: none;
  padding: 10px 30px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s;
  height: 80px;
  font-size: 24px;
}

.confirm-btn:hover {
  background: #40a9ff;
  transform: scale(1.05);
}

.confirm-btn.restart {
  background: #52c41a;
}

.confirm-btn.restart:hover {
  background: #73d13d;
}

/* 不同结果样式 */
.result-win .result-icon { color: #52c41a; }
.result-win .result-title { color: #52c41a; }

.result-lose .result-icon { color: #ff4d4f; }
.result-lose .result-title { color: #ff4d4f; }

.result-draw .result-icon { color: #faad14; }
.result-draw .result-title { color: #faad14; }

/* 按钮组样式 */
.action-buttons {
  display: flex;
  gap: 15px;
  margin-top: 20px;
  flex-direction: column;
}

.button {
  padding: 8px 16px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin: 5px;
}

.input-group {
  display: flex;
  margin: 10px 0;
}

.input-group input {
  flex: 1;
  padding: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  margin-right: 5px;
}

/* 桌面端适配 */
@media (min-width: 768px) {
  .action-buttons {
    flex-direction: row;
    justify-content: center;
  }

  .confirm-btn {
    width: auto;
    min-width: 120px;
  }

  .confirm-btn.restart {
    order: 0;
  }
}

/* 新增倒计时样式 */
.countdown-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: none;
}

.countdown-number {
  font-size: 200px;
  color: #fff;
  text-shadow: 0 0 20px rgb(255, 255, 255);
  animation: countdownPop 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

@keyframes countdownPop {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/page/pk.vue